import {getLogoutRedirectUrl} from '../url'
import React from "react";

export const Logout = () => {
    window.localStorage.clear();
    window.location.assign(getLogoutRedirectUrl());
    return <></>;
};
